<template>
	<v-container>
		<v-row justify="center">
			<v-col cols="12" sm="12">
				<v-data-table
					:headers="headers"
					:items="businesses"
					:items-per-page=15
					 :search="search"
					item.key='items.user_uid'
					no-data-text="Cargando Negocios ..."
					 v-if='loaded'
				>
					<!-- slot Top table -->
					<template v-slot:top>
						<v-toolbar flat color="white">
							<v-toolbar-title>Gestión de Negocios</v-toolbar-title>
							<v-divider class="mx-4" inset vertical></v-divider>
							<v-text-field
								v-model="search"
								append-icon="mdi-magnify"
								label="Search"
								single-line
								hide-details
							></v-text-field>
							
							<v-spacer />
							<business-dialog />
						</v-toolbar>
					</template>
					<!-- Fecha expiración -->
					<template v-slot:item.expiration_date="{ item }">
						
					 {{ timestampToDate(item.expiration_date) }}
					</template>
					<!-- Status -->
					<template v-slot:item.active="{ item }">
						<v-switch
								color="success"
								v-model="item.active"
								@change="toogleStatus(item)"
						></v-switch>
					</template>
					<!-- columna accion -->
					<template v-slot:item.action="{ item }">
						<v-icon color="admin_info " @click="go(item)" class="mr-2 iconos">
							mdi-eye
						</v-icon>
					<v-icon  color="admin_info"  @click="goSite(item)" class="mr-2 iconos ">
							mdi-laptop
					</v-icon>

			
						<v-icon  color="admin_info"  @click="goQr(item)"  class="mr-2 iconos">
							mdi-qrcode-scan
						</v-icon>
						<v-icon  color="admin_secondary "  @click="edit(item)" class="mr-2 iconos">
							mdi-file-edit
						</v-icon>
						<v-icon class="iconos" color="admin_accent " @click="categories(item)">
							mdi-folder-table
						</v-icon>
						
						 <v-icon class="iconos"
							@click="checkRemove(item, businesses.map(function(x) {return x.id; }).indexOf(item.id))"
							color="red"
						>
							mdi-delete
						</v-icon>
					</template>
				</v-data-table>

				<v-container v-else fill-height>
						<v-layout flex align-center justify-center>
						<v-progress-circular indeterminate :size="100" :widht="45" color="secondary" />
					</v-layout>
				</v-container>
			</v-col>
		</v-row>
		<QrDialog />


	</v-container>
</template>

<script>
	import { mapState, mapActions, mapGetters} from 'vuex';
	import moment from 'moment';
	import { db } from '@/main';
	export default {
		name: 'BusinessAdmin',
		components: {
			BusinessDialog: () => import('@/components/admin/BusinessDialog.vue'),
			QrDialog: () => import('@/components/admin/ReadQrDialog.vue')
 		},
		created(){
			this.getbusinesses()
		},
		data: () => ({
			idQr: '',
			search: '',
			headers: [
				{text: 'Ref', value: 'id', align: 'left'},
				{text: 'Nombre', value: 'name', align: 'left'},
				{text: 'Cliente', value: 'customer_name', align: 'left'},
				{text: 'Expiración', value: 'expiration_date', align: 'left'},
				{text: 'Estado', value: 'active', align: 'left'},
				{text: '', value: 'action', sortable: false,align: 'end', },
			],
			items: []
		}),
		methods: {
			...mapActions('businessModule', ['getbusinesses','toggleBusinessDialog','setBusiness']),
			...mapActions('categoryModule', ['setLoaded','setDialogList','getCategories']),
			goQr(item){
				this.$store.commit('SETQR',{show_qr: true, value_qr: item.id}, {root: true});
				//this.idQr = item.id;
				// this.dialogQr = true;
			},
			edit(business){
				this.toggleBusinessDialog({editMode: true, business})
			},
		
			remove(item,i)
			{
				console.log(item)
				console.log(i)
			},
			toogleStatus(item){
				db.collection('bussiness').doc(item.id).update({ active: item.active });
			},
			categories(item){
				this.$router.push(
					{
						name: 'AdminCategories', 
						params: {
							business_id: item.id, 
							business_name: item.name
						}
					})
			},
			go(item){  
					window.open("https://menu-qr.web.app/i/"+item.id, "_blank"); 
			},
			goSite(item){  
					window.open("https://menu-qr.web.app/web/"+item.id, "_blank"); 
			},
			async checkRemove(item,i){
				let del = false;
					await db.collection('bussiness').doc(item.id).collection('categories').get()
					.then(snap => {
						if (!snap.empty) { 
							this.$store.commit('SET_ALERT_MESSAGE', {
								show: 'true',
								color: 'admin_info',
								message: 'EXISTEN CATEGORIAS, Debe removerlas para eliminar Negocio',
								timeout: 3000 });	
						} else {
							del = true;
						}
					});
					if (del){
								var res =  confirm('Borrará un Negocio. Operación no tiene reverso');
								if (res) {
									await db.collection('bussiness').doc(item.id).delete();
									this.$store.commit('SET_ALERT_MESSAGE', {
										show: true,
										color: 'error',
										message: 'Negocio eliminado ',
										timeout: 1000
									});	
								}
						} 
			},

			timestampToDate(expiration){
				return moment.unix(expiration).format('DD-MM-YYYY');
			}

		},
		computed: {
			...mapState('businessModule',['businesses','business']),
			...mapState(['loaded','alert','showQr','valueQr']),
			...mapGetters('businessModule',['businessForEdit', 'businessDialogEditMode','businessesDialog']),
		
		},
	}
</script>

<style>

	button.v-btn.v-btn--flat.v-btn--text.theme--light.v-size--default.primary--text{
		color:red !important;
	}
    .iconos {

font-size: xx-large !important;		
	}
  
</style>